import { create } from 'zustand'
import api from '../utils/api'
import toast from 'react-hot-toast'
import logger from '../utils/logger'

export const useAuthStore = create((set, get) => ({
  user: null,
  isLoading: true,
  isLoginLoading: false,

  login: async (credentials) => {
    set({ isLoginLoading: true })
    logger.log('Sending login request')
    try {
      const response = await api.post('/api/auth/login', credentials)
      const { user, token } = response.data

      localStorage.setItem('token', token)
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`

      set({ user, isLoginLoading: false })
      toast.success('Добро пожаловать!')

      return { success: true }
    } catch (error) {
      set({ isLoginLoading: false })
      const message = error.response?.data?.message || 'Ошибка входа'
      toast.error(message)

      return { success: false, message }
    }
  },

  register: async (userData) => {
    set({ isLoginLoading: true })
    try {
      // Attach acquisition data captured on first visit (UTM + referrer).
      const { getStoredAcquisition, clearStoredAcquisition } = await import('../utils/acquisition')
      const acquisition = getStoredAcquisition()
      const payload = acquisition ? { ...userData, acquisition } : userData
      const response = await api.post('/api/auth/register', payload)
      if (acquisition) clearStoredAcquisition()
      const { user, token } = response.data
      
      localStorage.setItem('token', token)
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
      
      set({ user, isLoginLoading: false })
      toast.success('Аккаунт успешно создан!')
      
      return { success: true }
    } catch (error) {
      set({ isLoginLoading: false })
      const message = error.response?.data?.message || 'Ошибка регистрации'
      toast.error(message)
      
      return { success: false, message }
    }
  },

  logout: async () => {
    try {
      await api.post('/api/auth/logout')
    } catch (error) {
      logger.error('Logout error:', error)
    } finally {
      localStorage.removeItem('token')
      delete api.defaults.headers.common['Authorization']
      set({ user: null })
      toast.success('Вы вышли из системы')
    }
  },

  checkAuth: async () => {
    const token = localStorage.getItem('token')
    
    if (!token) {
      set({ isLoading: false, user: null })
      return
    }

    try {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await api.get('/api/auth/me')
      
      set({ user: response.data.data, isLoading: false })
    } catch (error) {
      localStorage.removeItem('token')
      delete api.defaults.headers.common['Authorization']
      set({ user: null, isLoading: false })
    }
  },

  updateProfile: async (profileData) => {
    try {
      const response = await api.put('/api/auth/profile', profileData)
      const updatedUser = response.data.data
      
      set({ user: updatedUser })
      toast.success('Профиль обновлен!')
      
      return { success: true }
    } catch (error) {
      const message = error.response?.data?.message || 'Ошибка обновления профиля'
      toast.error(message)
      
      return { success: false, message }
    }
  },

  changePassword: async (passwordData) => {
    try {
      await api.put('/api/auth/password', passwordData)
      toast.success('Пароль изменен!')

      return { success: true }
    } catch (error) {
      const message = error.response?.data?.message || 'Ошибка смены пароля'
      toast.error(message)

      return { success: false, message }
    }
  },

  // Завершить онбординг тур
  completeOnboarding: async () => {
    try {
      const response = await api.post('/api/users/onboarding/complete')
      const { onboardingCompletedAt } = response.data.data

      // Обновляем user в сторе
      set((state) => ({
        user: state.user ? { ...state.user, onboardingCompletedAt } : null
      }))

      // Отправляем событие для других компонентов (модалка обновлений)
      window.dispatchEvent(new CustomEvent('onboarding-completed'))

      return { success: true }
    } catch (error) {
      logger.error('Complete onboarding error:', error)
      return { success: false }
    }
  },
}))